var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"logo_top"},[(_vm.getTenantData)?_c('el-image',{staticClass:"img",attrs:{"src":_vm.echoImg(_vm.getTenantData.icon)}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }